import { toMoment } from '@core/utils/time';
import { CommonService } from '@business/services';
import { HWChecklistTemplateResponse } from '@business/entities/home';
import {
  TemplateStatus,
  ChecklistRecurring,
  ChecklistTemplateResponse,
  CompactChecklistTemplateResponse,
  CompactChecklistResponse,
} from '@business/entities/checklist';
import { R } from '@core/utils/r';

export function getStatusClass(status: TemplateStatus) {
  switch (status) {
    case 'overDue':
      return 'badge-soft-danger';
    case 'needAction':
      return 'badge-soft-primary';
    case 'completed':
      return 'badge-soft-success';
    case 'notActionable':
      return 'badge-soft-secondary';
  }
}
export function getStatusTitle(status: TemplateStatus) {
  switch (status) {
    case 'overDue':
      return 'Overdue';
    case 'needAction':
      return 'Need Action';
    case 'completed':
      return 'Completed';
    case 'notActionable':
      return 'Not Actionable';
  }
}

export function getRecurringTypes() {
  return [ChecklistRecurring.oneTime, ChecklistRecurring.daily, ChecklistRecurring.weekly, ChecklistRecurring.monthly, ChecklistRecurring.yearly];
}

export function getTypeValue(type: ChecklistRecurring) {
  switch (type) {
    case ChecklistRecurring.oneTime:
      return 'One Time';
    case ChecklistRecurring.daily:
      return 'Daily';
    case ChecklistRecurring.weekly:
      return 'Weekly';
    case ChecklistRecurring.monthly:
      return 'Monthly';
    case ChecklistRecurring.yearly:
      return 'Yearly';
    case ChecklistRecurring.oneTime:
      return 'One Time';
  }
}

export function getRecurringInfo(checklist: ChecklistTemplateResponse | CompactChecklistTemplateResponse | CompactChecklistResponse | HWChecklistTemplateResponse) {
  if (checklist.recurring === ChecklistRecurring.oneTime) {
    return 'One Time';
  } else if (checklist.recurring === ChecklistRecurring.weekly) {
    return `Every ${CommonService.getDayByValue(checklist.date)}`;
  } else if (checklist.recurring === ChecklistRecurring.monthly) {
    const m = toMoment().date(checklist.date);
    return `Every month on ${m.format('Do')}`;
  } else if (checklist.recurring === ChecklistRecurring.yearly) {
    const m = toMoment(checklist.date);
    return `On ${m.format('MMM Do')}`;
  } else if (checklist.recurring === ChecklistRecurring.daily) {
    const checklistDays = checklist.days;
    let text = '';
    checklistDays.forEach(d => {
      text = R.isEmpty(text) ? text + `${CommonService.getDayByValue(d)}` : text + `, ${CommonService.getDayByValue(d)}`;
    });
    return `Every ${text}`;
  }
}

export function getChecklistFrequency() {
  return [
    { label: 'Weekly', value: 'Weekly' },
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Quarterly', value: 'Quarterly' },
    { label: 'Bi-Yearly', value: 'Bi-Yearly' },
    { label: 'Yearly', value: 'Yearly' },
  ];
}
